var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "BjDivider",
      staticClass: "bj-divider",
      class: (_vm.$slots.default ? " " : " noPadding ") + _vm.size,
      style: "width:" + _vm.width,
    },
    [
      _c("div", { staticClass: "left" }, [
        _vm.$slots.default
          ? _c("span", { staticClass: "default-text" }, [_vm._t("default")], 2)
          : _vm._e(),
        _c("div", { staticClass: "button" }, [_vm._t("button")], 2),
        _c("span", { staticClass: "tips" }, [_vm._t("tips")], 2),
      ]),
      _c(
        "div",
        {
          staticClass: "right",
          class: { fixed: _vm.isFixed },
          attrs: { id: "rightBtnFixed" },
        },
        [_vm._t("right")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }